import { StyleSheet } from 'react-native';
import Theme from 'Theme/index';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';

const textCommon = {
    fontFamily: Theme.regularFont,
    textAlign: 'justify'
};

const baseStyles = {
    ...dialogCommon,
    windowMobile: {
        flex: 1,
        justifyContent: 'center',
        paddingHorizontal: Theme.primaryMargin
    },
    gradientContainer: {
        position: 'absolute',
        top: -80,
        width: '100%',
        height: 80
    },
    gradient: {
        width: '100%',
        height: 80
    },
    buttonContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column-reverse',
        paddingLeft: Theme.BU / 2,
        paddingRight: Theme.BU / 2
    },
    button: {
        width: '100%',
        marginTop: Theme.BU / 2,
        marginBottom: Theme.BU / 2
    },
    title: {
        ...dialogCommon.title,
        marginTop: dialogCommon.title.marginBottom + Device.isAndroid * 12,
        marginLeft: 8,
        fontFamily: Theme.ultraFont
    },
    subTitle: {
        ...dialogCommon.title,
        marginLeft: 8,
        marginTop: 0,
        marginBottom: 0,
        fontFamily: Theme.regularFont,
        flex: 1,
        textAlign: 'left'
    },
    backIconContainer: {
        position: 'absolute',
        top: 12,
        right: 0,
        left: 0,
        bottom: 0
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch'
    },
    iconBox: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 15,
        marginBottom: 20
    },
    logo: {
        alignSelf: 'flex-start',
        width: 100,
        height: 100,
        borderRadius: 5
    },
    greyText: {
        ...textCommon,
        fontSize: Theme.fontSizes.description,
        color: Theme.primaryTextColor,
        textAlign: 'left'
    },
    launchMarketing: {
        ...textCommon,
        fontSize: Theme.fontSizes.description,
        color: Theme.primaryTextColor,
        textAlign: 'left',
        marginBottom: 60
    },
    backgroundImage: {
        flex: 1,
        justifyContent: 'center'
    },
    safeAreaContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.95)'
    },
    scrollViewContainer: {
        flex: 1
    },
    contentScrollview: {
        justifyContent: 'center'
    },
    descriptionBox: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingRight: 48,
        paddingTop: 15,
        paddingBottom: 15
    },
    infoContainer: {
        marginTop: 15,
        marginBottom: 15
    },
    infoIcon: {
        width: 35,
        height: 35,
        marginRight: 15
    }
};

const dialogTablet = {
    windowTablet: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: Theme.primaryMargin,
        maxWidth: Device.isWeb ? 1244 : 'auto',
        marginLeft: Device.isWeb ? 'auto' : 0,
        marginRight: Device.isWeb ? 'auto' : 0
    },
    whiteText: {
        ...textCommon,
        fontSize: Theme.primaryFontSize,
        color: Theme.primaryTextColor,
        paddingVertical: 12,
        width: Device.isTabletOrWeb ? 500 : 300
    },
    greyText: {
        ...textCommon,
        color: Theme.primaryTextColor,
        fontSize: Theme.primaryFontSize,
        paddingLeft: 15,
        flex: 1
    },
    launchMarketing: {
        ...textCommon,
        color: Theme.primaryTextColor,
        fontSize: Theme.primaryFontSize
    },
    lineMarginTop: {
        marginTop: 17
    },
    title: {
        fontSize: Device.isTabletOrWeb ? 32 : 28,
        color: Theme.primaryTextColor,
        fontWeight: '300'
    },
    subTitle: {
        ...textCommon,
        color: Theme.primaryTextColor,
        fontSize: Theme.primaryFontSize,
        marginTop: 15
    },
    button: {
        minWidth: 100,
        marginTop: 25,
        maxWidth: 200,
        alignSelf: 'center'
    },
    buttonsConteiner: {
        justifyContent: 'center'
    },
    headerContainer: {
        flexDirection: 'row',
        alignSelf: 'stretch',
        alignItems: 'center',
        marginBottom: Device.isTabletOrWeb ? 17 : 28
    },
    headerTextContainer: {
        paddingLeft: 20,
        flexShrink: 1
    },
    logo: {
        alignSelf: 'flex-start',
        width: 122,
        height: 122,
        borderRadius: 5
    },
    logoContainer: {
        alignSelf: 'flex-start'
    }
};

const landscapeStyles = StyleSheet.create({
    ...dialogTablet,

    platformTablet: {
        fontSize: 25,
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        fontWeight: '500',
        alignSelf: 'flex-start',
        position: 'absolute',
        left: 30,
        top: 10
    },
    platformWeb: {
        fontSize: 23,
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        fontWeight: '500',
        position: 'absolute',
        left: 50,
        top: 40
    },
    buttonContainer: {
        alignSelf: 'stretch',
        alignItems: 'center',
        flexDirection: 'row',
        marginTop: 70
    },
    infoContainer: {
        flexDirection: 'row',
        paddingTop: 17,
        width: '100%'
    },
    buttonCancel: {
        ...baseStyles.button,
        width: '15%',
        maxWidth: '15%',
        marginLeft: 0
    },
    buttonContinue: {
        ...baseStyles.button,
        width: '30%',
        maxWidth: '30%',
        marginLeft: 15
    },
    backgroundImage: {
        flex: 1,
        justifyContent: 'center'
    },
    safeAreaContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.85)'
    },
    scrollViewContainer: {
        flex: 1
    },
    contentScrollview: {
        justifyContent: 'center',
        height: Device.isWeb ? '100%' : 'auto',
        flexGrow: 1
    },
    infoIcon: {
        width: 35,
        height: 35
    }
});

export { landscapeStyles };
export default StyleSheet.create(baseStyles);
